import { type BoxProps, Stack } from '../index';
import { SelectableButton, type SelectableButtonProps } from './SelectableButton';

export interface SelectableButtonChecklistProps {
  /**
   * Array of objects, one for each button. Each object contains the following properties: text, selected, onClick, onHover
   */
  items: SelectableButtonProps[];
  /**
   * Controls the gap between the buttons
   */
  gap?: BoxProps['gap'];
}

export const SelectableButtonChecklist = ({
  items,
  gap = 'xsmall',
}: SelectableButtonChecklistProps): JSX.Element => {
  const btnElements = items.map((item, i) => (
    // biome-ignore lint/suspicious/noArrayIndexKey: historic
    <SelectableButton key={`selectable-button-number-${i}`} {...item} />
  ));

  return <Stack gap={gap}>{btnElements}</Stack>;
};
